import {action, toJS} from 'mobx';
import Validator from 'validatorjs/src/validator';
import isEmpty from 'lodash/isEmpty';

class FormStore {
    getFlattenedValues = (valueKey = 'value') => {
        const data = {};
        const form = toJS(this.form).fields;
        Object.keys(form).forEach((key) => {
            data[key] = form[key][valueKey];
        });
        return data;
    };

    @action
    onChange = (field, value) => {
        this.form.fields[field].value = value;
        const validation = new Validator(
            this.getFlattenedValues('value'),
            this.getFlattenedValues('rule')
        );
        this.form.meta.isValid = validation.passes();
        if (!isEmpty(this.form.fields[field].error)) {
            this.form.fields[field].error = validation.errors.first(field);
        }
    };

    @action
    onBlur = (field) => {
        const validation = new Validator(
            this.getFlattenedValues('value'),
            this.getFlattenedValues('rule')
        );
        this.form.meta.isValid = validation.passes();
        if (!isEmpty(this.form.fields[field].value)) {
            this.form.fields[field].error = validation.errors.first(field);
        }
    };

    @action
    setError = (errMsg) => {
        this.form.meta.error = errMsg;
    }
}

export default FormStore;
